export default __webpack_public_path__ + "static/media/Security-pana.8cd7fc9d.svg";